import Config from '@config';
import { CACHE_EXPIRATION_TIME } from '@gasbi/shared/common/features/constants';

import { injectHouseholdsSlice } from '@/app/householdsApi';
import { UserPermissionType } from '@/features/permissions/types';

// Households Billing's permissions (GSB-8308), the «Організації» block's included: it works over the same API.
export const permissionsApi = injectHouseholdsSlice({
  baseUrl: Config.VITE_API_URL + '/users',
  tagTypes: ['UserPermissions'],
  keepUnusedDataFor: CACHE_EXPIRATION_TIME,
  endpoints: builder => ({
    getUserPermissions: builder.query<UserPermissionType[], void>({
      query: () => ({
        url: `/permissions`,
      }),
      providesTags: ['UserPermissions'],
    }),
  }),
});

export const { useGetUserPermissionsQuery } = permissionsApi;
